import { render, staticRenderFns } from "./CustomersGrid.vue?vue&type=template&id=197b18dc&"
import script from "./CustomersGrid.vue?vue&type=script&lang=js&"
export * from "./CustomersGrid.vue?vue&type=script&lang=js&"
import style0 from "./CustomersGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports